import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcFlagShape } from '@bibliocommons/bc-prop-types';
import { selectFlaggedContentVisibility } from 'app/selectors/bibs/ContentWarningsSelector';
import { selectFlagEntities } from 'app/selectors/EntitiesSelector';
import contentWarningActions from 'app/actions/ContentWarningActions';
import { ContentWarningPanel } from '.';

export class ContentWarningPanelContainer extends React.PureComponent {
  render() {
    return <ContentWarningPanel {...this.props} />;
  }
}

ContentWarningPanelContainer.propTypes = {
  flags: ImmutablePropTypes.mapOf(ugcFlagShape),
  flaggedContentVisibility: ImmutablePropTypes.mapOf(PropTypes.bool),
  contentWarningActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  flags: selectFlagEntities(state),
  flaggedContentVisibility: selectFlaggedContentVisibility(state).get('all')
});

const mapDispatchToProps = dispatch => ({
  contentWarningActions: bindActionCreators(contentWarningActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentWarningPanelContainer);
